import { FamilyCard } from '@fs/zion-tree-person-info-cards'
import { DialogOverlay, DialogOverlayActions, DialogOverlayFooter, Paragraph, TextField, Button } from '@fs/zion-ui'
import React, { useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { mapSpouseRelationshipToFamily } from '../../relationship/relationshipUtils'

export default function SwitchRelationshipSpousesDialog({ relationship, onClose, onOk, ...overlay }) {
  const { t } = useTranslation()
  const [reason, setReason] = useState('')
  const families = {}
  const parentsList = []
  const spouseRelationship = { spouse: relationship.spouse2 }
  const family = mapSpouseRelationshipToFamily(spouseRelationship, relationship.spouse2.personId, relationship.spouse1)
  const focusElementRef = useRef()

  if (family) {
    // // switch spouses
    const parent2 = family.parent2
    family.parent2 = family.parent1
    family.parent1 = parent2
  }

  parentsList.push(family)
  families.spouses = parentsList
  families.parents = []
  return (
    <DialogOverlay
      {...overlay}
      focusref={focusElementRef}
      aria-labelledby="form-dialog-title"
      title={t('person.reference.confirmSwitchPersons', 'Confirm Switching Persons')}
    >
      <Paragraph size="sm">
        {t(
          'person.relationships.switchPersonsConfirmation',
          'Are you sure you want to switch persons in this relationship to following:'
        )}
      </Paragraph>
      {families && families.spouses && (
        <FamilyCard
          focusFamily={families.spouses[0]}
          focusPersonId="BMKQ-18N"
          families={families}
          type="couple"
          data-testid="switch-spouses-family-card"
        />
      )}
      <TextField
        ref={focusElementRef}
        label={t('reason', 'Reason')}
        value={reason}
        onChange={(event) => setReason(event.target.value)}
      />
      <DialogOverlayFooter>
        <DialogOverlayActions>
          <Button id="confirmSwitchSpousesInRelationshipBtn" onClick={() => onOk(reason)} type="submit" emphasis="high">
            {t('action.confirm', 'Confirm')}
          </Button>
          <Button id="cancelSwitchSpousesInRelationshipBtn" onClick={onClose}>
            {t('action.cancel', 'Cancel')}
          </Button>
        </DialogOverlayActions>
      </DialogOverlayFooter>
    </DialogOverlay>
  )
}
